// packages import
import { Box, TextField } from '@mui/material'
import { FC, useEffect, useState, useContext } from 'react'
import { useDebounce } from 'use-debounce'

// component imports
import StatusFilter from './StatusFilter'
import MatterFilter from './MatterFilter'

// others
import { FundRequestsContext } from '../../../../context/FundRequestsContext'

const FundRequestsFilters: FC = () => {
  const { filters, setFilters } = useContext(FundRequestsContext)

  const [searchTerm, setSearchTerm] = useState<string>('')

  const [debouncedSearchTerm] = useDebounce(searchTerm, 500)

  useEffect(() => {
    if (debouncedSearchTerm === filters.searchTerm) return

    setFilters({ searchTerm: debouncedSearchTerm })

    // Just need the filters value on initial render, if we pass filters.searchTerm as a dependency it will cause a infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm, setFilters])

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value)
  }

  return (
    <Box display="flex" gap={2} alignItems="center" flexWrap="wrap" sx={{ px: 2, pt: 3, pb: 4 }}>
      <MatterFilter />
      <StatusFilter />

      <TextField
        label="Search"
        placeholder="Search by matter # or bill ID"
        value={searchTerm}
        onChange={handleSearchChange}
        sx={{ minWidth: 250, ml: 'auto' }}
      />
    </Box>
  )
}

export default FundRequestsFilters
